// extracted by mini-css-extract-plugin
module.exports = {"empty":"ahw7M","message":"ygJe7","bg":"h9oZ+","content":"knsbB","artImg":"_2h0mG"};